var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Mobile Menu"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Legal-Mob","transform":"translate(-315.000000, -11.000000)","fill":"#FFFFFF"},React.createElement("g",{"id":"mobile-menu","transform":"translate(315.000000, 11.000000)"},React.createElement("g",{"id":"Group"},[React.createElement("rect",{"id":"Rectangle","x":"0","y":"0","width":"44","height":"2","key":0}),React.createElement("rect",{"id":"Rectangle-Copy","x":"0","y":"10","width":"44","height":"2","key":1}),React.createElement("rect",{"id":"Rectangle-Copy-2","x":"0","y":"20","width":"44","height":"2","key":2})]))))]);
}

Menu.defaultProps = {"width":"44px","height":"22px","viewBox":"0 0 44 22","version":"1.1"};

module.exports = Menu;

Menu.default = Menu;
